/**
 * @generated SignedSource<<58df6effbcc7c5fe246edccbb949832a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AnnouncementComments_chat_SocialThreadCommentsFragment$data = {
  readonly id: string;
  readonly reference: string;
  readonly " $fragmentSpreads": FragmentRefs<"CommentsThread_chat_socialThread">;
  readonly " $fragmentType": "AnnouncementComments_chat_SocialThreadCommentsFragment";
};
export type AnnouncementComments_chat_SocialThreadCommentsFragment$key = {
  readonly " $data"?: AnnouncementComments_chat_SocialThreadCommentsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AnnouncementComments_chat_SocialThreadCommentsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AnnouncementComments_chat_SocialThreadCommentsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reference",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CommentsThread_chat_socialThread"
    }
  ],
  "type": "SocialThread",
  "abstractKey": null
};

(node as any).hash = "2aaa118bc3fc40874dd0676c103bd969";

export default node;
